import React from 'react';
import { useStoreon } from 'storeon/react';
import PropTypes from 'prop-types';

import TextareaWarranty from '../TextareaWarranty';

const BlockContactMethodWarranty = (props) => {
  const { index, placeholder, number = true } = props;
  const { groups } = useStoreon('groups');

  return (
    <fieldset className="form-block" disabled={groups[index].disabled}>
      <legend className="form-block__title">{number ? index + 1 + '. ' : ''}Additional Information</legend>
      <TextareaWarranty
        name="additional_comments"
        placeholder={placeholder}
      />

      {!groups[index].disabled && groups[index + 1] && groups[index + 1].disabled && (
        <div className={'form-block__error'}>
          You must fill in all required fields prior to moving to the next section.
        </div>
      )}
    </fieldset>
  );
};

BlockContactMethodWarranty.propTypes = {
  index: PropTypes.number.isRequired,
};

export default BlockContactMethodWarranty;
